module.exports = __webpack_public_path__ + "img/7.540f09bf.png";